import createIcon from '../../createIcon';

/**
 * @component @name VerticalShades
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgMTlWM0g0VjE5SDJWMjFIMjJWMTlIMjBaTTEwIDE5VjVIMTRWMTlIMTBaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const VerticalShades = createIcon('VerticalShades', [
  ['path', { d: 'M20 19V3H4V19H2V21H22V19H20ZM10 19V5H14V19H10Z', key: 'qzc7m2' }],
]);

export default VerticalShades;
